import { AppRoute } from '~/config';

export type CloudFormationDemo = Demo & {
  zipURL: string;
  template: unknown;
  stackName: string;
};

export type Demo = {
  title: string;
  services: string[];
  image: string;
  route: string;
};

export const quickStartNavLinks = [
  { label: 'Cloud Pods', href: AppRoute.QUICKSTART },
  { label: 'Cloud Formation', href: AppRoute.QUICKSTARTCLOUDFORMATION },
];
